module.exports = __webpack_public_path__ + "static/media/product_use_case_3.7683a06c.svg";